/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
         
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
          
           if (Cookies.get('cookie_agree') !== 'true') {
              $('#cookie-notice').fadeIn('fast');
          }
          
          $('#cookie-notice').on('click tap', '.close-col > a', function() {
             Cookies.set('cookie_agree',true);
             $('#cookie-notice').fadeOut('fast');
          });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
          $('.bxslider').bxSlider({
              minSlides: 1,
              maxSlides: 3,
              moveSlides: 1,
              slideWidth: 400,
              slideMargin: 30,
              shrinkItems: true,
              auto: ($(".bxslider li").length > 1) ? true: false,
              pager: ($(".bxslider li").length > 1) ? true: false,
              easing: 'ease-in-out',
              touchEnabled: false,
              controls: false
          });
      }
    },
      
      // Blog
      
    'page_template_template_blog': {
        init: function() {
            
        },
        finalize: function() {
            
            $(document).on('change','#search-filter', function(e){
                e.preventDefault();
                $(this).closest('#search_form').submit();
                
            });
            $(document).on('submit', '#search_form', function(e) {
                var $form = jQuery(this);
                var $input = $form.find('input[name="s"]');
                var query = $input.val();
                var $content = jQuery('#search-content');
                var $order = $form.find('select[name="search-filter"]');
                var order = $order.val();
               e.preventDefault();

                $.ajax({
                    type : 'post',
                    url : myAjax.ajaxurl,
                     data : {
                        action : 'load_search_results',
                        query : query,
                        orderBy : order
                    },
                    beforeSend: function() {
                        $input.prop('disabled', true);
                        $content.addClass('loading');
                    },
                    success : function( response ) {
                       $content.fadeOut('fast').html(response).fadeIn('fast');
                    }, 
                    
                    error : function( error ) {
                        console.log(error);
                    }, 
                    complete: function() {
                        $input.prop('disabled', false);
                        $content.removeClass('loading');
                    }
                });
                return false;
            });
        }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_about': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
    finalize: function() {
        $('.bxslider').bxSlider({

              easing: 'ease-in-out',
              controls: false,
              adaptiveHeight: true,
              touchEnabled: false,
              auto: ($(".bxslider li").length > 1) ? true: false,
              pager: ($(".bxslider li").length > 1) ? true: false,
                onSliderLoad: function(){
                $("#slides-container").css("visibility", "visible");
              }
          });
    }
    },
      
      'page_template_template_speaking': {
      init: function() {
        
      },
    finalize: function() {
            $('.event-title-row').on('click tap', function(e) { 
                e.preventDefault();
                $(e.currentTarget).toggleClass('open');
                $(e.currentTarget).siblings('.event-details-row').slideToggle('fast');
            });
    }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
